export default "__VITE_ASSET__CFIZ0zxt__"